import { useCallback, useMemo } from 'react'
import { FormikHelpers } from 'formik'
import { message } from 'antd'
import { useParams } from 'react-router-dom'
import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate'
import { FormOptions } from '@shared/modules/form/types'
import { DepartmentsService } from '../services'
import { DepartmentFormData } from '../types'
import { useDepartmentFormInitialData } from './use-form-initial-data'

export const useDepartmentForm = ({ type = 'create', redirectUrl }: FormOptions) => {
  const { id = '' } = useParams<{ id?: string }>()
  const navigate = useBackgroundNavigate()
  const baseInitialValues = useMemo<DepartmentFormData>(() => ({ id, departmentCode: '', departmentName: '', descr: '', stateId: '' }), [id])

  const initialValues = useDepartmentFormInitialData({ id: id, initialValues: baseInitialValues })

  const onSubmit = useCallback(
    async (values: DepartmentFormData, helpers: FormikHelpers<DepartmentFormData>) => {
      helpers.setStatus(null)
      const result = await DepartmentsService.createOrUpdate(values, type)

      if (result.status === 200) {
        if (redirectUrl) {
          navigate(redirectUrl)
        } else {
          helpers.resetForm()
        }
        message.success('Məlumatlar müvəffəqiyyətlə yeniləndi.')
      } else if (result.status === 422) {
        helpers.setErrors(result.data)
      } else {
        helpers.setStatus({ type: 'error', message: result.data })
      }
    },
    [navigate, redirectUrl, type],
  )

  return { initialValues, onSubmit }
}
